<template>
  <div id="app">
    <div class="eyebrow" style="margin-top:-15px">
      Florida High School Athletic Association
    </div>

    <div class="logobar">
      <div class="titlebar">
        <div class="row">
          <div class="col-12 col-sm-6 text-left">
            <div style="padding-left: 160px">Championships presented by Spectrum</div>
          </div>
          <div class="d-none d-sm-block col-6 text-right">
            <div style="padding-right: 15px">
              <a href="https://www.fhsaa.com" target="_top" style="color:#00B999">Return to FHSAA.com</a>
            </div>
          </div>
        </div>
      </div>
      <a href="#/" class="site-logo"></a>
    </div>


    <div class="container-fluid" style="min-height:calc(100vh - 365px)">
      <router-view/>
    </div>

    <div style="background: #fff; opacity:0.8;margin:50px 0 0 0;padding:30px 30px 0 30px;text-align:center;font-size:14px;line-height:14px;">
      <div class="row" style="align-items:center">
        <div class="col-sm-4 text-center text-sm-left" style="margin-bottom:30px">
          <!--FHSAA<br>-->
        </div>
        <div class="col-sm-4" style="margin-bottom:30px">
          Powered by &nbsp;
          <a href="https://www.boxcast.com" target="_blank">
            <img alt="BoxCast" src="https://cdn2.hubspot.net/hub/484866/file-2483746126-png/Logos/NewBoxCastLogo.png?t=1473431021465" style="height:14px;margin-top:-4px;">
          </a>
        </div>
        <div class="col-sm-4 text-center text-sm-right" style="margin-bottom:30px">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Config from '@/config'
export default {
  name: 'app',
  data () {
    return {
      channels: Config.staticChannels
    }
  },
  mounted () {

  },
  methods: {
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 15px;
}
.ellipse, .jumbotron h1 {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.fixed-16-9 {
  position: relative;
  padding-bottom: 56.25%; /* 16:9 */
  height: 0;
  background: black;
}
.fixed-16-9 > * {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

@media (max-width: 767px) {
  .col-sm-0 {
    display: none;
  }
}

#boxcast-container .boxcast-well {
  /* reset */
  border: none;
  box-shadow: none;
  text-align: left;
  padding: 0;
  margin: 0;

  /* clean */
  margin-top: 15px;
  padding: 15px;
}



/* red: #E21F3C */
/* dark: #000E1B */
/* blue: #0B59A3 */
/* ohsaa green: #00853e*/
/* fhsaa blue: #E4EDF2*/
/* fhsaa teal: #00B999*/

body {
  background: url(./assets/2018_page_bg.jpg) no-repeat 50% 0,
              url(./assets/2018_bg_grey_pattern.png) repeat;
  background-color:#aaa;
}
.card {
  background-color: #00B999;
  border-color: #00B999;
}
.card-body {
  background-color: #00B999;
  color: #ddd;
}
.channel-nav {
  color: #00B999;
}
.list-group-item {
  background-color: #0a6b37; /*dark green*/
  color: #ddd;
}
.list-group-item-action:focus, .list-group-item-action:hover {
  background-color: #0a6b37; /*dark green*/
  color: #fff;
}
.list-group-item.active {
  border-color: #00B999;
  background-color: #00B999;
  color: #fff;
}
.boxcast-theme-light .boxcast-well {
  /*background-color: #ff671b;
  color: #ddd;*/
}
.boxcast-theme-light .boxcast-ticket-button {
  background: #00B999;
  border-color: #2ea063;
  color: white;
  font-size: 1.2em;
  display: block;
  width: 100%;
  font-weight: bold;
  border-width: 3px;
  padding: 8px;
}


/* from sprite */
.eyebrow {
  background: #00B999;
  color: #fff;
  padding: 10px;
  font-weight: bold;
  text-transform: uppercase;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.logobar {
  background: #FFF;
  padding-top: 5px;
  height: 75px;
  border-bottom: 1px solid #ccc;
  margin-bottom: 15px;
}
.titlebar {
  background: transparent;
  color: #00B999;
  font-weight: bold;
  padding: 15px;
}
.site-logo {
  position: absolute;
  left: 10px;
  margin-left: 0;
  top: 40px;
  width: 150px;
  height: 100px;
  text-indent: -9999px;
  background: url(./assets/fhsaav1_logo.png) no-repeat;
  background-size: contain;
}
</style>



// WEBPACK FOOTER //
// src/App.vue